document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-announce-track]').forEach(function (track) {
    var viewport = track.closest('.custom-announce__viewport');
    var firstGroup = track.querySelector('[data-announce-group]');
    if (!viewport || !firstGroup) return;

    var templateHTML = firstGroup.outerHTML;

    function addGroup() {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = templateHTML;
      var groupEl = wrapper.firstElementChild;
      groupEl.setAttribute('aria-hidden', 'true');
      track.appendChild(groupEl);
    }

    // 8 groups are already rendered server-side (see the section's
    // liquid file) as a safe baseline. This only ADDS more on top if an
    // unusually wide screen still isn't covered twice over - it never
    // wipes/rebuilds what's already there, so there's nothing to fail
    // silently on.
    function topUp() {
      var containerWidth = viewport.clientWidth;
      var safety = 0;
      while (track.scrollWidth < containerWidth * 2 && safety < 40) {
        addGroup();
        safety++;
      }

      var groupCount = track.querySelectorAll('.custom-announce__group').length;
      if (groupCount % 2 !== 0) {
        addGroup();
      }
    }

    topUp();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(topUp, 200);
    });
  });
});